/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetYoutubeCapabilitiesQueryResponse, GetYoutubeCapabilitiesPathParams } from "../models/GetYoutubeCapabilities";

export function getGetYoutubeCapabilitiesUrl(station: GetYoutubeCapabilitiesPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube/${station}/capabilities` as const }
  return res
}

/**
 * @description Returns which actions the stored OAuth credentials can perform (upload, delete, add to playlists)
 * @summary Get YouTube connection capabilities for a station
 * {@link /youtube/:station/capabilities}
 */
export async function getYoutubeCapabilities(station: GetYoutubeCapabilitiesPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubeCapabilitiesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubeCapabilitiesUrl(station).url.toString(), ... requestConfig })
  return res.data
}